module.exports = __webpack_public_path__ + "static/media/check.7daf05ee.svg";